import React, { useEffect, useState } from 'react';
import {
  Box,
  Icon,
  SimpleGrid,
  useColorModeValue,
  Button,
  Flex
} from '@chakra-ui/react';
import {
  MdAttachMoney,
  MdCreditCard,
  MdPerson,
  MdRedo,
  MdShowChart,
  MdSecurity
} from 'react-icons/md';
import Card from 'components/card/Card';
import MiniStatistics from 'components/card/MiniStatistics';
import IconBox from 'components/icons/IconBox';
import ReferralsTable from 'views/admin/main/ecommerce/referrals/components/ReferralsTable';
import resguardosApi from 'api/resguardos';
import { useNavigate } from 'react-router-dom';
import { MdAdd } from "react-icons/md";

export default function Referrals() {
  const brandColor = useColorModeValue('brand.500', 'white');
  const boxBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');
  const navigate = useNavigate();

  const [cantidadActivos, setCantidadActivos] = useState(0);
  const [cantidadDePersonasConResguardo, setcantidadDePersonasConResguardo] = useState(0);

  const textColor = useColorModeValue('secondaryGray.900', 'white');
  useEffect(() => {
    async function fetchData() {
      try {
        const data = await resguardosApi.listado();
        setCantidadActivos(data.length);
      } catch (error) {
        console.error('Error al cargar los resguardos:', error);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
  async function fetchData() {
    try {
      const data = await resguardosApi.listado();

      // Crear un conjunto con los usuarioNumColab únicos (ignorando null/undefined)
      const unicos = new Set(
        data
          .filter((item: { usuarioNumColab: any; }) => item.usuarioNumColab) // elimina los vacíos o nulos
          .map((item: { usuarioNumColab: any; }) => item.usuarioNumColab)    // extrae solo los números de colaborador
      );

      // Guarda la cantidad de usuarios únicos
      setcantidadDePersonasConResguardo(unicos.size);

    } catch (error) {
      console.error('Error al cargar los resguardos:', error);
    }
  }

  fetchData();
}, []);



  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>

      {/* Botón Crear Activo alineado a la derecha */}
      <Flex justifyContent="flex-end" mb="10px">

      </Flex>

      {/* Estadísticas */}
      <SimpleGrid columns={{ base: 1, md: 2, xl: 5 }} gap="20px" mb="20px">
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={<Icon w="32px" h="32px" as={MdSecurity} color={brandColor} />}
            />
          }
          name="Cantidad de Resguardos"
          value={cantidadActivos.toLocaleString()}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={<Icon w="32px" h="32px" as={MdShowChart} color={brandColor} />}
            />
          }
          name="Valor en Resguardo"
          value="-"
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={<Icon w="32px" h="32px" as={MdPerson} color={brandColor} />}
            />
          }
          name="Colaboradores con Resguardo"
          value={cantidadDePersonasConResguardo.toLocaleString()}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={<Icon w="32px" h="32px" as={MdCreditCard} color={brandColor} />}
            />
          }
          name="Promedio de Resguardo"
          value="-"
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={<Icon w="32px" h="32px" as={MdRedo} color={brandColor} />}
            />
          }
          name="Tasa de Devolución"
          value="-"
        />
      </SimpleGrid>

      {/* Tabla */}
      <Card>
        <ReferralsTable />
      </Card>
    </Box>
  );

}
